const APP_ACCESS_TOKEN_KEY = 'app_access_token'

export function getClientAccessToken() {
  if (typeof window === 'undefined') return null
  const token = localStorage.getItem(APP_ACCESS_TOKEN_KEY)
  if (!token) return null
  // Check expiry client-side without server call
  try {
    if (token.startsWith('app_')) {
      const parts = token.slice(4).split('.')
      if (parts.length === 3) {
        const payload = JSON.parse(atob(parts[1].replace(/-/g, '+').replace(/_/g, '/')))
        if (payload.exp && payload.exp <= Math.floor(Date.now() / 1000)) {
          localStorage.removeItem(APP_ACCESS_TOKEN_KEY)
          return null
        }
      }
    }
  } catch { /* ignore decode errors */ }
  return token
}

export function setClientAccessToken(token: string) {
  if (typeof window === 'undefined') return
  localStorage.setItem(APP_ACCESS_TOKEN_KEY, token)
}

export function clearClientAccessToken() {
  if (typeof window === 'undefined') return
  localStorage.removeItem(APP_ACCESS_TOKEN_KEY)
}

